import {
  DownloadOptions,
  UseDownloadJsonOptions,
  UseDownloadJsonResponse,
} from "./types";

export const useDownloadJson = (
  options?: UseDownloadJsonOptions
): UseDownloadJsonResponse => {
  const f = ({ fileName, data }: DownloadOptions) => {
    let filename = fileName || "export.json";
    let contentType = "application/json;charset=utf-8;";
    //@ts-ignore
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var blob = new Blob(
        [decodeURIComponent(encodeURI(JSON.stringify(data)))],
        { type: contentType }
      );
      //@ts-ignore
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      var a = document.createElement("a");
      a.download = filename;
      a.href =
        "data:" + contentType + "," + encodeURIComponent(JSON.stringify(data));
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  return {
    download: f,
  };
};
